<div class="container">
    <div class="row d-flex flex-column">
        <h2>Welcome to GetPaid!</h2>
        <p>Ready to get started? Let's walk you through it!</p>
    </div>
</div>